import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from './alertify.service';
import { StateVM, OperationResult, LocationVM } from '../models/ViewModels';
import { environment } from '../../environments/environment';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  locationApi = `${environment.apiUrl}/Location`;

  constructor(private http: HttpClient,
    private errorService: ErrorService,
    private alertify: AlertifyService) { }

  create(location: LocationVM) {
    return this.http.post(this.locationApi, location).pipe(
      map((response: OperationResult<LocationVM>) => {
        if (response.Success) {
          this.alertify.success("Ubicación creada exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  update(location: LocationVM) {
    return this.http.put(this.locationApi, location).pipe(
      map((response: OperationResult<LocationVM>) => {
        if (response.Success) {
          this.alertify.success("Ubicación editada exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  delete(id: string) {
    const uri = `${this.locationApi}?uuid=${id}`;
    return this.http.delete(uri).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Ubicación eliminada exitosamente.");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  activate(location: LocationVM) {
    const uri = `${this.locationApi}/ActivateRecord`;
    return this.http.put(uri, location).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Ubicación activada exitosamente");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  getAll() {
    return this.http.get(this.locationApi).pipe(
      map((response: OperationResult<LocationVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getDeleted() {
    const uri = `${this.locationApi}/GetDeleted`;;
    return this.http.get(uri).pipe(
      map((response: OperationResult<LocationVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getById(id: string) {
    const uri = `${this.locationApi}/GetByIdentifier?uuid=${id}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<LocationVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }
}
